import { Form, Input, Modal } from "antd";
import { useEffect } from "react";
import { validateToken } from "../../../components/Globais";
import { useMessage } from "../../../uteis/mensagens/useMessage";
import { Title } from "../styles";
import { useCadastrarAndamentoCompatibilidade } from "../hooks/useCadastrarAndamentoCompatibilidade";

export default function ModalNotas({
  isModalOpen,
  handleFechar,
  compatibilidadeId,
}: any) {
  const [formNotas] = Form.useForm();
  const { showSuccess, showError, contextHolder } = useMessage();
  const {
    cadastrar,
    isLoading,
    error,
    success,
    resetError,
    resetSuccess,
  } = useCadastrarAndamentoCompatibilidade();

  useEffect(() => {
    if (!isModalOpen) {
      formNotas.resetFields();
      resetError();
      resetSuccess();
    }
  }, [isModalOpen, formNotas, resetError, resetSuccess]);

  useEffect(() => {
    if (success) {
      showSuccess(success);
      formNotas.resetFields();
      resetSuccess();
      handleFechar();
    }
  }, [success, showSuccess, formNotas, resetSuccess, handleFechar]);

  useEffect(() => {
    if (error) {
      showError(error);
      resetError();
    }
  }, [error, showError, resetError]);

  const handleSalvar = async () => {
    if (!compatibilidadeId) {
      showError("Compatibilidade inválida para registrar anotação.");
      return;
    }

    const values = await formNotas.validateFields();
    const token = validateToken();

    await cadastrar(compatibilidadeId, {
      descricao: "Anotações",
      observacoes: values.observacoes.trim(),
      visibilidade: "ADM",
      criadoPorTipo: "ADM",
      criadoPorId: token?.id ?? null,
      metadata: {
        canal: "frontend",
      },
    });
  };

  return (
    <>
      {contextHolder}
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Salvar"
        onOk={handleSalvar}
        confirmLoading={isLoading}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          },
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          },
        }}
      >
        <Form form={formNotas} layout="vertical" name="anotacoes-compatibilidade">
          <Title>Anotações</Title>
          <Form.Item
            name="observacoes"
            label="Observação"
            rules={[
              {
                required: true,
                message: "Informe a observação.",
              },
              {
                validator(_, value) {
                  if (!value || value.trim()) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    new Error("Informe uma observação válida.")
                  );
                },
              },
            ]}
          >
            <Input.TextArea
              rows={8}
              placeholder="Digite a anotação da compatibilidade"
              maxLength={2000}
              showCount
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}
